import React from 'react';
import { useBuildHubData } from '@modules/build-hub/hooks/use-build-hub-data';
import { ExistingCollaborators } from '@modules/build-hub/components/build-hub-admin/ExistingCollaborators';
import { InviteCollaboratorsForm } from '@modules/build-hub/components/build-hub-admin/InviteCollaboratorsForm';

export const ManageCollaboratorForm: React.FC = () => {
    const { buildHub } = useBuildHubData();

    // Check if the user has permission to invite collaborators
    // Editors and Admins can invite, but Editors have restricted role options
    const canInviteCollaborators = buildHub.userPermissions.canEdit;

    return (
        <div>
            <div className="mb-8">
                <h2 className="text-2xl font-medium text-gray-900">
                    Our Project Team
                </h2>
                <p className="mt-2 text-gray-600">
                    {canInviteCollaborators
                        ? 'Invite people to collaborate on this project.'
                        : 'View team members for this project.'}
                </p>
            </div>
            <div className="divide-y-2 divide-gray-200 [&>*:not(:first-child)]:pt-5 [&>*:not(:last-child)]:pb-5">
                {canInviteCollaborators && (
                    <InviteCollaboratorsForm buildHub={buildHub} />
                )}
                <ExistingCollaborators />
            </div>
        </div>
    );
};
